<template> 
  <b-form @submit.prevent="save" novalidate class="mt-3">
    <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Organization Name" label-for="organization-name">
        <b-form-input
          autofocus
          id="organization-name"
          required
          type="text"
          v-model="editing.name"
        />
    </b-form-group>
    <!-- TODO more settings to come -->

    <b-tabs content-class="mt-3">
      <b-tab title="Caveon ID authenticated accounts" active>
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Prevent users from using old passwords" label-for="isPreventOldPasswords">
          <b-checkbox name="isPreventOldPasswords" v-model="editing.settings.is_prevent_old_passwords" inline plain></b-checkbox>
        </b-form-group>
      
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Password length requirement" label-for="pw_length">
          <b-form-input
            name="pw_length"
            type="number"
            v-model="editing.settings.pw_length"
          />
        </b-form-group>
    
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Password life (days)" label-for="pw_life">
          <b-form-input
            name="pw_life"
            type="number"
            v-model="editing.settings.pw_life"
          />
        </b-form-group>
    
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Password complexity" label-for="pw_complexity">
          <b-form-select
            :options="pwComplexityOptions"
            name="pw_complexity"
            v-model="editing.settings.pw_complexity"
          />
        </b-form-group>

        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Number of consecutive failed attempts" label-for="failed_attempts">
        <b-form-input name="failed_attempts" type="number" v-model="editing.settings.failed_attempts" inline></b-form-input>
        <b-form-text class="mt-1">Enter 0 to disable this setting.</b-form-text>
        </b-form-group>

        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Lockout time (minutes)" label-for="lockout_time">
        <b-form-input name="lockout_time" type="number" v-model="editing.settings.lockout_time" inline></b-form-input>
        <b-form-text class="mt-1">Enter 0 to disable this setting.</b-form-text>
        </b-form-group>
      </b-tab>

      <b-tab title="All accounts">
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Require 2 Factor Authentication" label-for="two_factor">
          <b-checkbox name="two_factor" v-model="editing.settings.two_factor_auth" inline plain></b-checkbox>
        </b-form-group>
    
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Require Security Question" label-for="require_security_question">
          <b-checkbox name="require_security_question" v-model="editing.settings.require_security_question" inline plain></b-checkbox>
        </b-form-group>
    
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Refresh token duration (seconds)" label-for="session_timeout" description="If a value is provided, it must be at least 11000. Anything under 11000 will be removed.">
          <b-form-input name="session_timeout" type="number" v-model.number="editing.settings.session_timeout" inline></b-form-input>
        </b-form-group>
    
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Idle timeout (seconds)" label-for="idle_timeout">
          <b-form-input name="idle_timeout" type="number" v-model.number="editing.settings.idle_timeout" inline></b-form-input>
        </b-form-group>

      </b-tab>

      <b-tab title="Advanced settings">
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Use this organization for SAML login" label-for="isSamlLogin">
          <b-checkbox name="isSamlLogin" v-model="editing.settings.is_saml_login" inline plain></b-checkbox>
        </b-form-group>
    
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="SAML entry point" label-for="url">
          <b-input type="url" name="entryPoint" v-model="editing.settings.entryPoint"></b-input>
        </b-form-group>
    
        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="SAML certificate" label-for="cert">
          <b-textarea name="cert" v-model="editing.settings.cert"></b-textarea>
        </b-form-group>

        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Allow IdP to choose authentication method" label-for="disableRequestedAuthnContext">
          <b-checkbox name="disableRequestedAuthnContext" v-model="editing.settings.disableRequestedAuthnContext" inline plain></b-checkbox>
          <b-form-text class="mt-1">Omits RequestedAuthnContext from the SAML request. Enable for identity providers such as Microsoft Entra ID when users authenticate with Windows Hello, FIDO2, certificate-based authentication, or other passwordless methods. Leave disabled to preserve the existing PasswordProtectedTransport behavior.</b-form-text>
        </b-form-group>

        <b-button v-if="editing.id && editing.settings.is_saml_login" variant="white" size="sm" @click="getSamlMetadata">Generate SAML metadata</b-button>
        <b-button v-if="metadataLink" variant="link" :href="metadataLink" :download="metadataName">Download metadata</b-button>

        <h5 class="mt-4 mb-3">SCIM Provisioning</h5>

        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Enable SCIM provisioning" label-for="scim_enabled">
          <b-checkbox name="scim_enabled" v-model="editing.settings.scim.enabled" inline plain></b-checkbox>
          <b-form-text class="mt-1">Allows Okta and Microsoft Entra ID to create, update, and deactivate users for this organization through SCIM 2.0.</b-form-text>
        </b-form-group>

        <div v-if="editing.settings.scim.enabled">
          <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="SCIM endpoint">
            <b-form-input :value="scimEndpoint" readonly />
          </b-form-group>

          <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Bearer token">
            <b-button :disabled="!editing.id" variant="white" size="sm" @click="generateScimToken">{{ hasScimToken ? 'Rotate Token' : 'Generate Token' }}</b-button>
            <b-form-text class="mt-1">Store this token in Okta or Entra ID. The full token is shown only once.</b-form-text>
            <b-alert v-if="generatedScimToken" show variant="warning" class="mt-2 mb-0">
              <div><strong>Copy this token now:</strong></div>
              <code class="text-break">{{ generatedScimToken }}</code>
            </b-alert>
          </b-form-group>

          <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="User matching">
            <b-form-select v-model="editing.settings.scim.match_strategy" :options="scimMatchStrategyOptions" />
            <b-form-text class="mt-1">Email matching is used by default and is compatible with Okta and Microsoft Entra ID.</b-form-text>
          </b-form-group>

          <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="When user is disabled">
            <b-form-select v-model="editing.settings.scim.disable_behavior" :options="scimDisableBehaviorOptions" />
          </b-form-group>

          <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Automatically reactivate users">
            <b-checkbox v-model="editing.settings.scim.auto_reactivate" inline plain></b-checkbox>
          </b-form-group>

          <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Domain restriction">
            <b-form-text class="mt-1">SCIM provisioning is always restricted to users whose email address matches this organization’s Email rules. This cannot be disabled.</b-form-text>
          </b-form-group>

          <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="Supported providers">
            <b-form-text class="mt-1">Okta and Microsoft Entra ID / Azure AD SCIM 2.0 provisioning are supported. User provisioning, user updates, and deactivation are enabled. Group provisioning is not included in this version.</b-form-text>
          </b-form-group>
        </div>

        <h5 class="mt-4 mb-3">IP Address Security</h5>

        <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="IP address validation" label-for="ip_address_security_mode">
          <b-form-select
            name="ip_address_security_mode"
            :options="ipAddressSecurityOptions"
            v-model="editing.settings.ip_address_security_mode"
          />
          <b-form-text class="mt-1">None disables IP address validation. Allowed IPs only permits matching addresses. Blocked IPs denies matching addresses.</b-form-text>
        </b-form-group>

        <div v-if="editing.settings.ip_address_security_mode !== 'none'">
          <b-form-group label-cols="12" label-cols-md="5" label-cols-lg="4" label="IP address entry" label-for="ip_address_security_entry">
            <b-input-group>
              <b-form-input
                name="ip_address_security_entry"
                v-model="ipAddressSecurityEntry"
                :state="ipAddressSecurityEntryState"
                placeholder="192.0.2.1, 192.0.2.0/24, or 192.0.2.1 - 192.0.2.25"
              />
              <b-input-group-append>
                <b-button :disabled="!ipAddressSecurityEntryState" :style="{ background: brandColor, borderColor: 'transparent' }" @click="addIPAddressSecurityEntry(ipAddressSecurityEntry)">+ Entry</b-button>
              </b-input-group-append>
              <b-form-invalid-feedback>Enter a valid IPv4 or IPv6 address, range, or CIDR block.</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-row>
            <b-col md="5" lg="4">
              &nbsp;
            </b-col>
            <b-col>
              <ul class="pl-0 ml-0 mt-2 unstyled">
                <li v-for="(entry, index) in ipAddressSecurityEntries" :key="index" class="border-bottom pt-2 pb-3 ">
                  {{ entry }}<b-button @click="removeIPAddressSecurityEntry(index)" variant="white" size="sm" class="ml-3 float-right">Delete</b-button>
                </li>
              </ul>
              <b-form-text v-if="!ipAddressSecurityEntries.length" class="text-danger">Add at least one entry when Allowed IPs or Blocked IPs is selected.</b-form-text>
            </b-col>
          </b-row>
        </div>
      </b-tab>

      <b-tab title="Email rules">
        <div>
          <b-form-group  label-cols="12" label-cols-md="5" label-cols-lg="4" label="Email rules" label-for="rule">
            <b-input-group>
              <b-input type="text" name="rule" v-model="rule" class="mr-1"></b-input>
              <b-button :disabled="!rule.length" :style="{ background: brandColor, borderColor: 'transparent' }" @click="addRule(rule)">+ Rule</b-button>
            </b-input-group>
          </b-form-group>
          <b-row>
            <b-col md="5" lg="4">
              &nbsp;
            </b-col>
            <b-col>
              <ul class="pl-0 ml-0 mt-2 unstyled">
                <li v-for="(rule, index) in emailRules" :key="index" class="border-bottom pt-2 pb-3 ">
                  {{ rule }}<b-button @click="removeRule(index)" variant="white" size="sm" class="ml-3 float-right">Delete</b-button>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </b-tab>
    </b-tabs>

    <br>
    <b-row class="d-flex flex-sm-row mt-3">
      <b-col class="mt-3">
        <b-button block :disabled="!validForm" type="submit" :style="{ background: brandColor, borderColor: 'transparent' }"
          >Save</b-button>
      </b-col>
      <b-col class="mt-3">
        <b-button block @click="hideModal" type="button" variant="white"
          >Cancel</b-button
        >
      </b-col>
    </b-row>
    <b-row v-if="editing.id" class="mt-3">
      <b-col class="text-right">
        <b-button @click="destroy" size="sm" type="button" variant="outline-danger"> Delete this organization</b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import { deepCopy } from '../utils/helpers'
  import { HTTP } from '../requests/requests'
  import { SESSION } from '../utils/session'


  async function save(org) {
    try {
      const protocol = org.id ? HTTP.put : HTTP.post
      const put = org.id ? `/${org.id}` : ''
      const response = await protocol(`/api/organizations${put}`, org)

      return response.data
    } catch (error) {
      return { error }
    }
  }

  async function destroy(id) {
    try {
      await HTTP.delete(`/api/organizations/${id}`)

      return {}
    } catch (error) {
      return { error }
    }
  }

  async function generateScimToken(id) {
    try {
      const response = await HTTP.post(`/api/organizations/${id}/scim-token`)

      return { data: response.data }
    } catch (error) {
      return { error }
    }
  }

  async function getSamlMetadata(id) {
    try {
      const response  = await HTTP.get(`/api/auth/saml/${id}/metadata`)

      return { data: response.data }
    } catch (error) {
      return { error }
    }
  }

  export default {
    name: 'OrgEdit',
    props: {
      org: {
        type: Object
      }
    },
    data() {
      return {
        editing: {},
        saving: false,
        rule: '',
        ipAddressSecurityEntry: '',
        scimMatchStrategyOptions: [
          { text: 'Email address', value: 'email' },
          { text: 'External ID', value: 'external_id' }
        ],
        scimDisableBehaviorOptions: [
          { text: 'Disable account', value: 'disable' },
          { text: 'Delete account', value: 'delete' }
        ],
        ipAddressSecurityOptions: [
          { text: 'None', value: 'none' },
          { text: 'Allowed IPs', value: 'allowed' },
          { text: 'Blocked IPs', value: 'blocked' }
        ],
        pwComplexityOptions: [
          {
            text: 'Any',
            value: 0
          },
          {
            text: 'Symbol or Number',
            value: 1
          },
          {
            text: 'Symbol and Number',
            value: 2
          }
        ],
        metadataLink: null,
        generatedScimToken: ''
      }
    },
    created() {
      this.editing = deepCopy(this.org)

      if (!this.editing.settings.rules) {
        this.editing.settings.rules = []
      }
      if (typeof this.editing.settings.disableRequestedAuthnContext === 'undefined') {
        this.$set(this.editing.settings, 'disableRequestedAuthnContext', false)
      }
      if (typeof this.editing.settings.failed_attempts === 'undefined') {
        this.editing.settings.failed_attempts = 0
      }
      if (typeof this.editing.settings.lockout_time === 'undefined') {
        this.editing.settings.lockout_time = 0
      }
      if (!this.editing.settings.ip_address_security_mode) {
        this.$set(this.editing.settings, 'ip_address_security_mode', 'none')
      }
      if (!Array.isArray(this.editing.settings.ip_address_security_entries)) {
        this.$set(this.editing.settings, 'ip_address_security_entries', [])
      }
      if (!this.editing.settings.scim) {
        this.$set(this.editing.settings, 'scim', {})
      }
      if (typeof this.editing.settings.scim.enabled === 'undefined') {
        this.$set(this.editing.settings.scim, 'enabled', false)
      }
      if (!this.editing.settings.scim.match_strategy) {
        this.$set(this.editing.settings.scim, 'match_strategy', 'email')
      }
      if (!this.editing.settings.scim.disable_behavior) {
        this.$set(this.editing.settings.scim, 'disable_behavior', 'disable')
      }
      if (typeof this.editing.settings.scim.auto_reactivate === 'undefined') {
        this.$set(this.editing.settings.scim, 'auto_reactivate', true)
      }
      this.$delete(this.editing.settings.scim, 'restrict_to_domains')
    },
    methods: {
      async save() {
        const response = await save(this.editing)

        if (response.error) {
          return
        }

        this.$emit('update', response)
      },
      async destroy() {
        if (this.editing.id) {
          await destroy(this.editing.id)
        }

        this.$emit('delete')
      },
      hideModal() {
        this.$emit('hide-modal')
      },
      addRule(rule) {
        this.editing.settings.rules.push(rule)
        this.rule = ''
      },
      removeRule(index) {
        const reactToChanges = { ...this.editing }

        reactToChanges.settings.rules.splice(index, 1)

        this.editing = { ...reactToChanges }
      },
      addIPAddressSecurityEntry(entry) {
        if (!this.isValidIPAddressSecurityEntry(entry)) return
        this.editing.settings.ip_address_security_entries.push(entry.trim())
        this.ipAddressSecurityEntry = ''
      },
      removeIPAddressSecurityEntry(index) {
        const reactToChanges = { ...this.editing }

        reactToChanges.settings.ip_address_security_entries.splice(index, 1)

        this.editing = { ...reactToChanges }
      },
      isValidIPAddressSecurityEntry(entry) {
        const value = (entry || '').trim()
        const ipv4 = '(25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})'
        const ipv4Address = `${ipv4}\\.${ipv4}\\.${ipv4}\\.${ipv4}`
        const ipv6Address = '([0-9a-fA-F]{1,4}:){2,7}[0-9a-fA-F]{1,4}|::1|::|([0-9a-fA-F]{1,4}:){1,7}:'
        const ipAddress = `(${ipv4Address}|${ipv6Address})`
        const ipRegex = new RegExp(`^${ipAddress}$`)
        const cidrRegex = new RegExp(`^${ipAddress}/([0-9]|[1-2][0-9]|3[0-2]|[4-9][0-9]|1[0-1][0-9]|12[0-8])$`)
        const rangeRegex = new RegExp(`^${ipAddress}\\s*-\\s*${ipAddress}$`)

        return ipRegex.test(value) || cidrRegex.test(value) || rangeRegex.test(value)
      },
      async generateScimToken() {
        if (!this.editing.id) return

        const response = await generateScimToken(this.editing.id)
        if (response.error) return

        this.generatedScimToken = response.data.token
        this.$set(this.editing.settings.scim, 'token_hash', true)
      },
      async getSamlMetadata() {
        this.clearMetadataObj()

        const response = await getSamlMetadata(this.editing.id)
        const data = new Blob([response.data],  { type: 'application/xml' })
        const file = new File([data], name)

        this.metadataLink = URL.createObjectURL(file, { oneTimeOnly: true })
      },
      clearMetadataObj() {
        if (this.metadataLink) {
          URL.revokeObjectURL(this.metadataLink)
          this.metadataLink = null
        }
      }
    },
    destroyed() {
      this.clearMetadataObj()
    },
    computed: {
      brandColor() {
        return SESSION.branding.color
      },
      validForm() {
        return this.editing.name && this.editing.name.length && this.editing.settings && this.ipAddressSecurityConfigValid
      },
      emailRules() {
        return this.editing.settings.rules
      },
      ipAddressSecurityEntries() {
        return this.editing.settings.ip_address_security_entries
      },
      ipAddressSecurityEntryState() {
        if (!this.ipAddressSecurityEntry) return null
        return this.isValidIPAddressSecurityEntry(this.ipAddressSecurityEntry)
      },
      ipAddressSecurityConfigValid() {
        if (!this.editing.settings || this.editing.settings.ip_address_security_mode === 'none') return true
        return this.ipAddressSecurityEntries.length > 0
      },
      metadataName() {
        return `${this.editing.name}-saml-metadata.xml`
      },
      scimEndpoint() {
        if (!this.editing.id) return 'Save this organization before configuring the SCIM endpoint.'
        return `${window.location.origin}/api/scim/v2/${this.editing.id}`
      },
      hasScimToken() {
        return !!(this.editing.settings && this.editing.settings.scim && this.editing.settings.scim.token_hash)
      }
    }
  }
</script>

<style scoped>
.unstyled {
  list-style: none;
}
</style>
